var F = Object.defineProperty;
var N = (n, t, e) => t in n ? F(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var C = (n, t, e) => N(n, typeof t != "symbol" ? t + "" : t, e);
import { M as H } from "../NaturalCompare-BhqAyIXe.js";
import { B as rt, H as st, N as it, S as ot, U as ct } from "../NaturalCompare-BhqAyIXe.js";
import { C as dt, I as ft, R as gt, a as ut, t as Et } from "../Ipv4Address-CbH6PWSk.js";
import "vue";
import * as L from "utif2";
import o from "moment";
class q {
  /**
  * クッキー情報からCSRF用のtokenを取得します。
  * @returns 値（なければnull)
  **/
  static getCSRFToken() {
    return this.getCookieData("XSRF-TOKEN");
  }
  /**
   * クッキー情報から引数のキー情報を取得します
   * @param tokenName cookieのキー
   * @returns 値（なければnull)
   */
  static getCookieData(t) {
    var A;
    const r = `; ${document.cookie}`.split(`; ${t}=`);
    return r.length === 2 && ((A = r.pop()) == null ? void 0 : A.split(";").shift()) || null;
  }
}
const l = class l {
  /*
   * ローディング開始
   */
  static Start() {
    l.loadingRef != null && (l.loadingcount++, l.loadingRef.startLoading());
  }
  /**
   * 開始されていなければローディング表示を開始します。
   * @return すでにローディング表示されていればfalse、表示されていなければtrueを返します。
   */
  static StartIfNeeded() {
    return l.loadingcount === 0 ? (l.Start(), !0) : !1;
  }
  /*
   * ローディング終了
   */
  static Stop() {
    l.loadingRef != null && l.loadingcount !== 0 && (l.loadingcount--, !(0 < l.loadingcount) && l.loadingRef.stopLoading());
  }
  /**
   * ローディングを強制的に終了します。
   */
  static ForceStop() {
    l.loadingRef != null && (l.loadingcount = 0, l.loadingRef.stopLoading());
  }
  /* 
   * ローディング画面の参照を登録
   * ★App.vue意外から呼び出さないこと★
   */
  static SetLoading(t) {
    l.loadingRef = t;
  }
};
// 参照カウンタ
C(l, "loadingcount", 0), /*
 * ローディング画面のrefs
 */
C(l, "loadingRef");
let x = l;
class X {
  /**
   * モーダル画面を表示します。awaitを組み合わせることでモーダル画面が閉じるまで待つことができます。
   * @param target モーダル画面を表示する要素またはそのID属性
   * @param options モーダル画面のオプション
   * @returns 非同期で結果を受け取るためのPromiseインスタンスを返します。
   *          awaitを併用することでモーダル画面を閉じるまで待つことができます。
   */
  static async doModal(t, e) {
    return new Promise((r) => {
      function A(i) {
        i.target && i.target.removeEventListener(H.Events.hidden, A), r();
      }
      let a = null;
      t instanceof HTMLElement ? a = t : typeof t == "string" && (a = document.getElementById(t)), a && (a.addEventListener(H.Events.hidden, A), new H(a, e).show());
    });
  }
}
class Q {
  /**
   * obj1とobj2が一致するかどうかテストします。
   * @param obj1 比較元
   * @param obj2 比較対象
   * @returns obj1とobj2が一致する場合はtrue、異なる場合はfalseを返します。
   */
  static equals(t, e) {
    const r = Q.getDiff(t, e);
    return 0 < Object.keys(r).length;
  }
  /**
   * obj1とobj2に指定されたJSONオブジェクトの差分を抽出します。
   * @param obj1 比較元
   * @param obj2 比較対象
   * @returns 差分がある箇所のobj2の値を返します。
   */
  static getDiff(t, e) {
    const r = {};
    for (const A in t)
      if (t.hasOwnProperty(A))
        if (!e.hasOwnProperty(A))
          r[A] = void 0;
        else if (typeof t[A] == "object" && typeof e[A] == "object") {
          const a = Q.getDiff(t[A], e[A]);
          0 < Object.keys(a).length && (r[A] = a);
        } else t[A] !== e[A] && (r[A] = e[A]);
    for (const A in e)
      e.hasOwnProperty(A) && !t.hasOwnProperty(A) && (r[A] = e[A]);
    return r;
  }
  /**
   * NULL または undefined か判定します
   * @param obj オブジェクト
   * @returns true: NULL または undefined false:それ以外
   */
  static isNullOrUndefined(t) {
    return t == null;
  }
}
class j {
  /**
   * 以下のルールに従って100分率を算出します。
   * - 0より大きく1未満の場合は有効桁数で切り上げ
   * - 99より大きく100未満の場合は有効桁数で切り捨て
   * - それ以外は有効桁数で切り捨て
   * @param dividend 被除数
   * @param divisor 序数
   * @param precision 有効桁数
   */
  static toPercentage(t, e, r) {
    if (e === 0)
      throw new Error("Divisor cannot be zero.");
    const A = t * 100 / e, a = Math.pow(10, r ?? 0);
    return 0 < A && A < 1 ? Math.ceil(A * a) / a : 99 < A && A < 100 ? Math.floor(A * a) / a : Math.round(A * a) / a;
  }
}
var _ = /* @__PURE__ */ ((n) => (n[n.None = 0] = "None", n[n.Png = 1] = "Png", n[n.Jpeg = 2] = "Jpeg", n[n.Bmp = 4] = "Bmp", n[n.Gif = 8] = "Gif", n[n.Jpg = 16] = "Jpg", n[n.Tiff = 32] = "Tiff", n[n.Tif = 64] = "Tif", n))(_ || {});
class B {
  /**
   * 画像の拡張子Bitから、MIME文字列を作成します
   */
  static GetMIMEType(t) {
    const e = [];
    return t & 1 && e.push("image/png"), t & 18 && e.push("image/jpeg"), t & 4 && e.push("image/bmp"), t & 8 && e.push("image/gif"), t & 96 && e.push("image/tiff"), e.join(",");
  }
  /**
   * 画像の拡張子Bitから、拡張子一覧を作成します
   */
  static GetExtensions(t) {
    const e = [];
    return t & 16 && e.push(".jpg"), t & 2 && e.push(".jpeg"), t & 1 && e.push(".png"), t & 64 && e.push(".tif"), t & 32 && e.push(".tiff"), t & 4 && e.push(".bmp"), t & 8 && e.push(".gif"), e.join(",");
  }
  /**
   * 画像の拡張子Bitから、有効な拡張子かを判断します
   */
  static ValidateExtensions(t, e) {
    var r = t.lastIndexOf(".");
    if (r === -1)
      return !1;
    let A = t.slice(r).toLowerCase();
    return B.GetExtensions(e).split(",").includes(A);
  }
  /**
   * @brief Canvasに描画された画像に透明度（アルファチャンネル）が含まれるかを判定します。
   * @param canvas 判定対象のHTMLCanvasElement
   * @returns 透明度を持つピクセルが1つでもあればtrue、なければfalseを返します。
   */
  static hasAlphaChannel(t) {
    const e = t.getContext("2d");
    if (!e)
      return !1;
    const A = e.getImageData(0, 0, t.width, t.height).data;
    for (let a = 3; a < A.length; a += 4)
      if (A[a] < 255)
        return !0;
    return !1;
  }
  /**
   * 画像ファイルをリサイズします
   */
  static AsyncImageResizing(t, e, r) {
    return new Promise((A, a) => {
      const i = t.type === "image/tiff" || /\.(tif|tiff)$/i.test(t.name), c = new FileReader();
      c.onload = (f) => {
        if (f.target === null || f.target.result === null) {
          a("Error: e.target.result is null");
          return;
        }
        if (i) {
          try {
            const s = f.target.result, E = L.decode(s);
            L.decodeImage(s, E[0]);
            const h = L.toRGBA8(E[0]), { width: m, height: D } = E[0], g = document.createElement("canvas"), S = g.getContext("2d");
            if (!S) return a("Error: Unable to get canvas context");
            const R = document.createElement("canvas"), U = R.getContext("2d");
            if (!U) return a("Error: Unable to get temp canvas context");
            R.width = m, R.height = D;
            const O = U.createImageData(m, D);
            O.data.set(h), U.putImageData(O, 0, 0);
            let Y = 1;
            if (e < m && (Y = e / m), r < D) {
              const I = r / D;
              I < Y && (Y = I);
            }
            if (g.width = m * Y, g.height = D * Y, S.drawImage(R, 0, 0, g.width, g.height), B.hasAlphaChannel(g))
              A(g.toDataURL("image/png"));
            else {
              const I = g.toDataURL("image/png"), v = g.toDataURL("image/jpeg");
              A(I.length <= v.length ? I : v);
            }
          } catch (s) {
            a(s);
          }
          return;
        }
        const u = new Image();
        u.onload = function() {
          var D;
          const s = document.createElement("canvas"), E = s.getContext("2d");
          if (E === null) {
            a("Error: Unable to get canvas context");
            return;
          }
          if (B.IsAnimatedGif((D = f.target) == null ? void 0 : D.result)) {
            a("Error: Animated GIF is not supported");
            return;
          }
          let h = 1;
          if (e < u.width && (h = e / u.width), r < u.height) {
            const g = r / u.height;
            g < h && (h = g);
          }
          if (s.width = u.width * h, s.height = u.height * h, E.drawImage(u, 0, 0, s.width, s.height), B.hasAlphaChannel(s))
            A(s.toDataURL("image/png"));
          else {
            const g = s.toDataURL("image/png"), S = s.toDataURL("image/jpeg");
            A(g.length <= S.length ? g : S);
          }
        }, u.onerror = (s) => a("Error loading image: " + s), u.src = f.target.result;
      }, c.onerror = (f) => {
        a("Error loading file:" + f);
      }, i ? c.readAsArrayBuffer(t) : c.readAsDataURL(t);
    });
  }
  /**
   * @brief GIFがアニメーションかどうかを判定します。
   * @param dataUrl 判定したいGIF画像のDataURL
   * @returns アニメーションGIFであればtrue、静止画GIFであればfalseを返します。
   */
  static IsAnimatedGif(t) {
    if (!t.startsWith("data:image/gif;base64,"))
      return !1;
    try {
      const e = {
        // ブロックタイプ識別子
        BLOCK_TYPE: {
          IMAGE_SEPARATOR: 44,
          // 各画像フレームの開始
          EXTENSION_BLOCK: 33,
          // 拡張ブロック(コメント, アニメーション制御など)
          GIF_FILE_END_MARKER: 59
          // ファイルの終端マーカー
        },
        // 構造上のオフセットとサイズ
        HEADER_SIZE: 6,
        LOGICAL_SCREEN_DESCRIPTOR_SIZE: 7,
        PACKED_FIELDS_INDEX: 10,
        IMAGE_DESCRIPTOR_SIZE: 9,
        // ビットマスク (特定のビットを調べるための道具)
        MASKS: {
          HAS_COLOR_TABLE: 128,
          // 1000 0000 (最上位ビット)
          COLOR_TABLE_SIZE: 7
          // 0000 0111 (下位3ビット)
        },
        BYTES_PER_COLOR: 3,
        // 1色あたりのバイト数 (R, G, B)
        DATA_SUB_BLOCK_END: 0
        // データサブブロックの終端
      }, r = t.split(",")[1], A = atob(r), a = new Uint8Array(A.length);
      for (let s = 0; s < A.length; s++)
        a[s] = A.charCodeAt(s);
      let i = 0, c = 0;
      c += e.HEADER_SIZE + e.LOGICAL_SCREEN_DESCRIPTOR_SIZE;
      const f = a[e.PACKED_FIELDS_INDEX];
      if ((f & e.MASKS.HAS_COLOR_TABLE) > 0) {
        const s = 1 << (f & e.MASKS.COLOR_TABLE_SIZE) + 1;
        c += e.BYTES_PER_COLOR * s;
      }
      for (; c < a.length; ) {
        const s = a[c];
        if (s === e.BLOCK_TYPE.IMAGE_SEPARATOR) {
          if (i++, i > 1)
            return !0;
          c += 1 + e.IMAGE_DESCRIPTOR_SIZE;
          const E = a[c - 1];
          if ((E & e.MASKS.HAS_COLOR_TABLE) > 0) {
            const m = 1 << (E & e.MASKS.COLOR_TABLE_SIZE) + 1;
            c += e.BYTES_PER_COLOR * m;
          }
          c++;
        } else if (s === e.BLOCK_TYPE.EXTENSION_BLOCK)
          c += 2;
        else if (s === e.BLOCK_TYPE.GIF_FILE_END_MARKER)
          return !1;
        for (; c < a.length && a[c] !== e.DATA_SUB_BLOCK_END; ) {
          const E = a[c];
          c += E + 1;
        }
        c++;
      }
      return i > 1;
    } catch {
      return !1;
    }
  }
}
let w;
const G = new Uint8Array(16);
function b() {
  if (!w && (w = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !w))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return w(G);
}
const d = [];
for (let n = 0; n < 256; ++n)
  d.push((n + 256).toString(16).slice(1));
function K(n, t = 0) {
  return d[n[t + 0]] + d[n[t + 1]] + d[n[t + 2]] + d[n[t + 3]] + "-" + d[n[t + 4]] + d[n[t + 5]] + "-" + d[n[t + 6]] + d[n[t + 7]] + "-" + d[n[t + 8]] + d[n[t + 9]] + "-" + d[n[t + 10]] + d[n[t + 11]] + d[n[t + 12]] + d[n[t + 13]] + d[n[t + 14]] + d[n[t + 15]];
}
const W = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), P = {
  randomUUID: W
};
function T(n, t, e) {
  if (P.randomUUID && !n)
    return P.randomUUID();
  n = n || {};
  const r = n.random || (n.rng || b)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, K(r);
}
const p = class p {
  /**
   * データURIからファイル名を作成
   * @param   [in]    dataURI : データURI
   * @param   [in]    prefix : プレフィックス
   * @return  ファイル名（GUIDで作成）
   */
  static CreateFileName(t, e = void 0) {
    let r = "";
    return t.startsWith("data:image/png") ? r = "png" : t.startsWith("data:image/jpeg") ? r = "jpg" : r = "", e == null ? `${T()}.${r}` : `${e}_${T()}.${r}`;
  }
  /**
   * データURI⇒FileContentDataURI
   * @param   [in]    dataURI : データURI
   * @return  FileContentDataURI（※ファイル名はGUIDで作成）
   */
  static DataURIToFileContent(t) {
    return {
      dataURI: t,
      fileName: p.CreateFileName(t),
      fileSize: p.DataURItoFileSize(t)
    };
  }
  /*
  * HTML内のデータURIをファイル名に変換
  * @param   [in]    srcHtml : HTMLテキスト(<img>のsrcはデータURI)
  * @return  [in]    callbackSetFileList : ファイル情報をセットするコールバック関数
  * @return  fileList: 変換したファイル情報
  */
  static DataURIsToFileNames_InHTML(t, e) {
    let r = t;
    if (r.indexOf("img", 0) !== void 0) {
      const A = /<img[^>]*?src="([^"]*?)"[^>]*?>/gi;
      let a, i = r;
      for (; (a = A.exec(r)) !== null; ) {
        const c = a[1], f = p.DataURIToFileContent(c);
        e(f.dataURI, f.fileName, f.fileSize), i = i.replace(f.dataURI, f.fileName);
      }
      r = i;
    }
    return r;
  }
  /*
  * HTML内のファイル名をデータURIに変換
  * @param   [in]    srcHtml : HTMLテキスト(<img>のsrcはファイル名)
  * @param   [in]    callbackGetFileInfo : ファイル情報を取得するコールバック関数（dataURI: データURI, fileName: ファイル名）
  * @return  srcHtml内のファイル名をデータURIに置き換えた文字列
  */
  static FileNamesToDataURIs_InHTML(t, e, r) {
    let A = t;
    for (let a = 0; a < e; a++) {
      const i = r(a);
      i.fileName !== void 0 && i.fileName !== null && i.dataURI !== void 0 && i.dataURI !== null && (A = A.replace(i.fileName, i.dataURI));
    }
    return A;
  }
  /*
  * HTML内の<img>タグのsrcを列挙します
  * @param   [in]    srcHtml : HTMLテキスト
  * @return  srcHtml内のsrc一覧
  */
  static EnumImgSrc_inHtml(t) {
    const e = new Array();
    if (t.indexOf("img", 0) !== void 0) {
      const r = /<img[^>]*?src="([^"]*?)"[^>]*?>/gi;
      let A;
      for (; (A = r.exec(t)) !== null; ) {
        const a = A[1];
        e.push(a);
      }
    }
    return e;
  }
  /*
  * データURIの文字列から、バイナリ時のサイズを計算します
  * @param   [in]    dataURI : データURI
  * @return  バイナリ時のファイルサイズ
  */
  static DataURItoFileSize(t) {
    const e = t.replace(/^data:.*;base64,/, ""), r = e.length;
    return Math.ceil(r * 3 / 4) - (e.endsWith("==") ? 2 : e.endsWith("=") ? 1 : 0);
  }
  /*
   * データURIが取得失敗の画像かどうか
   * @param   [in]    dataURI : データURI
   */
  static IsPicFailedImage(t) {
    return t.toUpperCase() === p.PIC_FAILED_IMAGE.toUpperCase();
  }
};
/**
 * 取得失敗の画像
 */
C(p, "PIC_FAILED_IMAGE", "data:image/jpeg;base64,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");
let y = p;
class $ {
  /**
   * 文字列がMACアドレスの形式（コロンまたはハイフン区切り）であるかを判定します。
   * @param text - 検証する文字列
   * @returns MACアドレス形式の場合はtrue、それ以外はfalseを返します。
   */
  static isMacAddress(t) {
    return t ? /^([0-9A-Fa-f]{2}[-]){5}[0-9A-Fa-f]{2}$/.test(t) : !1;
  }
  /**
   * 文字列がIPv4であるかを判定します。
   * @param text - 検証する文字列
   * @returns CIDRの場合はtrue、それ以外はfalseを返します。
   */
  static isIPv4(t) {
    return !t || !/^([0-9]{1,3}\.){3}[0-9]{1,3}$/.test(t) ? !1 : t.split(".").every((A) => {
      if (1 < A.length && A.startsWith("0"))
        return !1;
      const a = parseInt(A, 10);
      return 0 <= a && a <= 255;
    });
  }
  /**
   * 文字列がClassless Inter-Domain Routing（CIDR）であるかを判定します。
   * @note CIDRは"192.168.0.0/16"のように「<先頭アドレス>/<ネットワーク部のビット数>」という形式を指します。
   * @param text - 検証する文字列
   * @returns CIDRの場合はtrue、それ以外はfalseを返します。
   */
  static isCIDR(t) {
    return !t || !/^([0-9]{1,3}\.){3}[0-9]{1,3}\/([0-9]|[1-2][0-9]|3[0-2])$/.test(t) ? !1 : t.split("/")[0].split(".").every((a) => {
      if (1 < a.length && a.startsWith("0"))
        return !1;
      const i = parseInt(a, 10);
      return 0 <= i && i <= 255;
    });
  }
}
const tt = (n, t, e) => {
  const A = JSON.stringify({
    sender: t,
    value: e
  });
  window.open(n, A);
}, et = (n, t) => {
  try {
    if (!window.name)
      throw new Error("No state found in window.name");
    const e = JSON.parse(window.name);
    if (e.sender !== t)
      throw new Error("Invalid sender");
    return e.value;
  } catch {
    window.location.href = n;
  }
  return "";
}, M = {
  /** YYYY/MM/DD HH:mm:ss */
  YYYY_MM_DD_HH_MM_SS: "YYYY/MM/DD HH:mm:ss",
  /** YYYY/MM/DD HH:mm */
  YYYY_MM_DD_HH_MM: "YYYY/MM/DD HH:mm",
  /** YYYYMMDDHHmmss */
  YYYYMMDDHHMMSS: "YYYYMMDDHHmmss",
  /** YYYY/MM/DD */
  YYYY_MM_DD: "YYYY/MM/DD",
  /** YYYYMMDD */
  YYYYMMDD: "YYYYMMDD",
  /** HHMM */
  HHMM: "HHmm",
  /** HH:MM */
  HH_MM: "HH:mm"
};
class At {
  /**
   * 現在日時取得します
   */
  static now() {
    return o().toDate();
  }
  /**
   * 現在日時を文字列で取得します。
   * @param format 文字列フォーマット デフォルト：YYYY/MM/DD HH:mm:ss
   */
  static nowFormat(t = M.YYYY_MM_DD_HH_MM_SS) {
    return o().format(t);
  }
  /**
   * 日付のフォーマット変換をします。
   * @param date 変換対象の日付
   * @param format 文字列フォーマット デフォルト：YYYY/MM/DD
   */
  static format(t, e = M.YYYY_MM_DD) {
    return o(t).format(e);
  }
  /**
   * 文字列(string)から日付(Date)に変換します
   * @param value 変換対象の日付文字列
   * @param format 文字列フォーマット デフォルト：YYYY/MM/DD
   */
  static toDate(t, e = M.YYYY_MM_DD) {
    return o(t, e).toDate();
  }
  /**
   * 日付加算
   * @param date 基準日時
   * @param format 加算する日数
   */
  static addDays(t, e) {
    return o(t).add(e, "days").toDate();
  }
  /**
   * 月加算
   * @param date 基準日時
   * @param format 加算する月数
   */
  static addMonths(t, e) {
    return o(t).add(e, "months").toDate();
  }
  /**
   * 年加算
   * @param date 基準日時
   * @param format 加算する年数
   */
  static addYears(t, e) {
    return o(t).add(e, "years").toDate();
  }
  /**
   * 月初取得
   * @param date 基準日時
   */
  static startOfMonth(t) {
    return o(t).startOf("month").toDate();
  }
  /**
   * 月末取得
   * @param date 基準日時
   */
  static endOfMonth(t) {
    return o(t).endOf("month").toDate();
  }
  /**
   * 日初取得
   * @param date 基準日時
   */
  static startOfDay(t) {
    return o(t).startOf("day").toDate();
  }
  /**
   * 日末取得
   * @param date 基準日時
   */
  static endOfDay(t) {
    return o(t).endOf("day").toDate();
  }
  /**
   * 日数差
   * @param fromDate 開始日時
   * @param to 終了日時
   */
  static diffDays(t, e) {
    return o(e).diff(o(t), "days");
  }
  /**
   * 分差
   * @param fromDate 開始日時
   * @param to 終了日時
   */
  static diffMinutes(t, e) {
    return o(e).diff(o(t), "minutes");
  }
  /**
   * 同日判定(date1の日付 === date2の日付)
   * @param date1 比較対象1
   * @param date2 比較対象2
   */
  static isSameDate(t, e) {
    return o(t).isSame(e, "day");
  }
  /**
   * 前か(date1 < date2)
   * @param date1 比較対象1
   * @param date2 比較対象2
   */
  static isBefore(t, e) {
    return o(t).isBefore(e);
  }
  /**
   * 後か(date1 > date2)
   * @param date1 比較対象1
   * @param date2 比較対象2
   */
  static isAfter(t, e) {
    return o(t).isAfter(e);
  }
  /**
   * 土日判定
   * @param date 基準日時
   */
  static isWeekend(t) {
    const e = o(t).day();
    return e === 0 || e === 6;
  }
  /**
   * うるう年判定
   * @param date 基準日時
   */
  static isLeapYear(t) {
    return o(t).isLeapYear();
  }
  /**
   * 文字列変換(YYYYMMDD)
   * @param date 返還前
   */
  static toYYYYMMDD(t) {
    return o(t).format(M.YYYYMMDD);
  }
  /**
   * 文字列変換(YYYYMMDDHHmmss)
   */
  static toYYYYMMDDHHmmss(t) {
    return o(t).format(M.YYYYMMDDHHMMSS);
  }
  /**
   * 文字列変換(HHmm)
   */
  static toHHmm(t) {
    return o(t).format(M.HHMM);
  }
  /**
   * Null/Emptyチェック
   */
  static isEmpty(t) {
    return t == null || t === "" ? !1 : o(t).isValid();
  }
}
export {
  rt as BootstrapUtil,
  dt as ConvStorageUtil,
  q as CookieUtil,
  y as DataURIUtil,
  M as DateFormat,
  At as DateUtil,
  $ as FormatValidator,
  st as HttpRequestUtil,
  _ as ImageTypeBit,
  B as ImageUtil,
  ft as Ipv4Address,
  x as LoadingUtil,
  j as MathUtil,
  X as ModalUtil,
  it as NaturalCompare,
  Q as ObjectUtil,
  gt as RoundType,
  ot as StringHelper,
  ct as UUIDUtil,
  ut as toBitPositions,
  Et as toStringArray,
  tt as useOpenNewTabWithData,
  et as useReceiveDataFromNewTab
};
